import React, {FunctionComponent} from "react";
import {useIsMobileDevice} from "../../../hooks/useIsMobileDevice";
import {useDetectBrowser} from "../../../hooks/useDetectBrowser";
import {CONSTANTS} from "../../../common/constants";
import {FilePreviewerProps} from "../FilePreview";

export const PDFPreview: FunctionComponent<FilePreviewerProps> = (props) => {
    const isMobileDevice = useIsMobileDevice(false);
    const browser = useDetectBrowser();

    const getPDFViewerUrl = () => {
        if (isMobileDevice || browser === CONSTANTS.BROWSERS.IE) {
            return `https://webapp.fieldpulse.com/ViewerJS/#${props.file?.url}`;
        } else {
            return props.file?.url;
        }
    };

    const renderPDFPreview = () => {
        return <object data={getPDFViewerUrl()} type='application/pdf'>
            <embed src={getPDFViewerUrl()}/>
        </object>;
    };

    const renderPDFPreviewForSafari = () => {
        return <object data={getPDFViewerUrl()}>
            <embed src={getPDFViewerUrl()}/>
        </object>;
    };

    return (
        <>
            {
                browser !== CONSTANTS.BROWSERS.Safari && renderPDFPreview()
            }
            {
                browser === CONSTANTS.BROWSERS.Safari && renderPDFPreviewForSafari()
            }
        </>
    );
};